/**
 * @deprecated Use withObjectSelected Hoc on @domain/object-selected/object-selected.hocs
 */
const mapObjectSelectedToProps = state => ({
    objectSelected: state.data.objectSelected,
});

export default mapObjectSelectedToProps;
